export default "__VITE_ASSET__BrSWcCZF__"